/**
 * Created by mac on 4/24/20
 */

CardView.prototype.ctor = cleverapps.extendFunc(CardView.prototype.ctor, function (card, ...rest) {
    this._super(card, ...rest);

    if (cleverapps.environment.isEditorScene()) {
        this.createFrame();
    }

    if (cleverapps.environment.isEditorScene() && !card.random) {
        this.createPoint();
    }

    card.on("addMark", this.addMark.bind(this));
    card.on("removeMark", this.removeMark.bind(this));
    card.on("editorRemove", this.removeFromParent.bind(this));
    card.on("editorColor", this.showSelected.bind(this));
    card.on("setActive", this.setActive.bind(this));
    card.on("setVisible", this.setVisible.bind(this));
    card.on("setLayerDimmed", this.setLayerDimmed.bind(this));

    if (cleverapps.environment.isEditorScene() && !card.disableEditorControls) {
        this.addCardControls();
        this.addCardClickHandler();
    }
});

CardView.prototype.createPoint = function () {
    const node = new cc.Sprite(bundles.editor.frames.editor_attetion_png);
    node.setScale(0.75);
    this.addChild(node);
    node.setAlignment(cleverapps.styles.CardViewControls.point);
};

CardView.prototype.addMark = function (type) {
    const markView = new MarkView(new Mark(type));
    this.addChild(markView);
    markView.show();
};

CardView.prototype.removeMark = function (type) {
    this.getChildren().forEach((child) => {
        if (child instanceof MarkView && child.mark && child.mark.type === type) {
            child.removeFromParent();
        }
    });
};

CardView.prototype.createFrame = function () {
    const image = cleverapps.config.type === "tile3" ? bundles.editor.frames.tile_frame : bundles.editor.frames.card_frame;
    const frame = this.frame = new cc.Sprite(image);
    frame.setLocalZOrder(1);
    frame.setAnchorPoint(this.animation.getAnchorPoint());
    frame.setPosition(this.animation.getPosition());
    this.addChild(frame);
    frame.setVisible(false);
};

CardView.prototype.toggleFrameVisibility = function (visible) {
    this.animation.setVisible(!visible);
    if (cleverapps.config.type === "tile3") {
        this.icon.setVisible(!visible);
    }
    this.frame.setVisible(visible);
};

CardView.prototype.changeChildrenVisibility = function (visible) {
    this.children.forEach((child) => {
        if (this.cardControls.indexOf(child) === -1) {
            child.visible = visible;
        }
    });
};

CardView.prototype.setActive = function (isActive) {
    if (isActive && !this.transparentImage || !isActive && this.transparentImage) {
        return;
    }

    if (isActive) {
        this.changeChildrenVisibility(true);

        this.transparentImage.removeFromParent();
        this.transparentImage = undefined;

        this.addCardClickHandler();
    } else {
        this.changeChildrenVisibility(false);

        this.transparentImage = new cc.Sprite(bundles.editor.frames.transparent_card);
        this.transparentImage.setOpacity(150);
        this.transparentImage.setPosition(this.width / 2, this.height / 2);
        this.addChild(this.transparentImage);

        if (this.clickHandler) {
            this.clickHandler.remove();
            this.clickHandler = undefined;
        }
    }
};

CardView.prototype.setLayerDimmed = function (isDimmed, selected) {
    if (this.layerDimmed === isDimmed) {
        return;
    }

    this.layerDimmed = isDimmed;
    this.showSelected(selected);
};

CardView.prototype.showSelected = function (selected) {
    this.setRecCascadeColorEnabled();

    let color = cleverapps.styles.COLORS.WHITE;
    if (selected) {
        color = cleverapps.styles.COLORS.YELLOW;
    } else if (this.layerDimmed) {
        color = cleverapps.styles.COLORS.DARK_TILE_COLOR;
    }
    this.setColor(color);

    if (!Game.currentGame.table.selectBlocksMode && !Game.currentGame.table.snapMode) {
        this.cardControls.forEach((control) => {
            control.setVisible(selected);
        });
    }
};

CardView.prototype.listCardControls = function () {
    let cardControls = [];

    if (cleverapps.config.type === "solitaire") {
        cardControls = cardControls.concat(this.getRotationControls());
    }
    cardControls = cardControls.concat(this.getZOrderControls());
    cardControls.push(this.getDeleteControl());

    return cardControls;
};

CardView.prototype.getRotationControls = function () {
    const styles = cleverapps.styles.CardViewControls.rotate;
    const controls = [];

    styles.forEach((rotateControl) => {
        const rotateIcon = new cc.Sprite(bundles.editor.frames.editor_rotate_arrow);
        rotateIcon.setRotation(rotateControl.rotate);
        rotateIcon.setAlignment(rotateControl);
        controls.push(rotateIcon);

        const calcAngle = function (touch) {
            const displacement = this.convertTouchToNodeSpaceDisplacement(touch);
            const x = (rotateIcon.x + displacement.x) - this.width / 2;
            const y = (rotateIcon.y + displacement.y) - this.height / 2;
            return Math.atan2(x, y) / Math.PI * 180 - rotateControl.baseAngle;
        }.bind(this);

        cleverapps.UI.onDrag(rotateIcon, {
            onDragMove: function (touch) {
                Game.currentGame.table.editorRotateCardView(calcAngle(touch));
            },
            onDragEnd: function (touch) {
                Game.currentGame.table.editorRotateCard(calcAngle(touch));
            }
        });
    });
    return controls;
};

CardView.prototype.getDeleteControl = function () {
    const styles = cleverapps.styles.CardViewControls.delete;
    const deleteIcon = new cc.Sprite(bundles.editor.frames.editor_delete_icon);
    deleteIcon.setAlignment(styles);
    cleverapps.UI.onClick(deleteIcon, () => {
        Game.currentGame.table.removeCardsEditor();
    });
    return deleteIcon;
};

CardView.prototype.getZOrderControls = function () {
    const styles = cleverapps.styles.CardViewControls;
    const controls = [];
    const orderDownIcon = new cc.Sprite(bundles.editor.frames.editor_orderdown_icon);
    orderDownIcon.setAlignment(styles.orderdown);
    controls.push(orderDownIcon);
    cleverapps.UI.onClick(orderDownIcon, () => {
        Game.currentGame.table.changeOrder(false);
        orderDownIcon.runAction(StandartAnimations.shake(orderDownIcon));
    });
    cleverapps.UI.applyHover(orderDownIcon);

    const orderUpIcon = new cc.Sprite(bundles.editor.frames.editor_orderup_icon);
    orderUpIcon.setAlignment(styles.orderup);
    controls.push(orderUpIcon);
    cleverapps.UI.onClick(orderUpIcon, () => {
        Game.currentGame.table.changeOrder(true);
        orderUpIcon.runAction(StandartAnimations.shake(orderUpIcon));
    });
    cleverapps.UI.applyHover(orderUpIcon);

    return controls;
};

CardView.prototype.canSetCard = function () {
    return true;
};

CardView.prototype.addCardControls = function () {
    this.cardControls = this.listCardControls();

    this.cardControls.forEach((control) => {
        control.setVisible(false);
        control.setLocalZOrder(20);
        this.addChild(control);
    });
};

CardView.prototype.addCardClickHandler = function () {
    const table = Game.currentGame.table;
    const orangery = Editor.currentEditor.orangery;
    let lastClick = 0;

    const move = function (touch, isDragEnd) {
        const displacement = this.convertTouchToNodeSpaceDisplacement(touch);
        if (isDragEnd && !this.canSetCard()) {
            displacement.x = 0;
            displacement.y = 0;
        }

        table[isDragEnd ? "editorCardMoveEnd" : "editorCardMove"]({
            x: displacement.x,
            y: displacement.y,
            r: 0
        });
    }.bind(this);

    this.clickHandler = cleverapps.UI.onDrag(this, {
        onClick: function (touch) {
            if (orangery.selected) {
                const point = this.convertTouchToNodeSpace(touch);

                const clickInCenter = cc.rectContainsPoint(
                    cc.rectScale(cc.rect(0, 0, this.width, this.height), 0.5),
                    point
                );

                if (orangery.selected.component) {
                    table.putComponent(this.card, orangery.selected);
                } else if (!clickInCenter) {
                    const tableView = table.getView().getParent();

                    const tablePos = tableView.convertTouchToNodeSpace(touch);
                    table.editorClicked({
                        x: tablePos.x,
                        y: tablePos.y
                    });
                } else if (orangery.selected.cardType) {
                    const newCard = {
                        x: this.card.x,
                        y: this.card.y,
                        CardCtor: orangery.selected.CardCtor,
                        cardOptions: orangery.selected.cardOptions
                    };

                    if (!this.card.magic) {
                        newCard.value = this.card.value;
                    } else {
                        newCard.random = true;
                    }

                    table.addNewCard(newCard);
                    table.removeCard(this.card);
                }

                return;
            }

            const now = Date.now();
            if (now - lastClick < PointerHandler.DOUBLE_CLICK_WAIT) {
                lastClick = 0;
                table.cardHeld(this.card);
                return;
            }
            lastClick = now;

            const isMultiSelect = EditorCardTable.IsMultiSelectPressed();
            if (!isMultiSelect) {
                table.clearSelection();
            }

            if (table.selected.has(this.card)) {
                isMultiSelect ? table.unselect(this.card) : table.select(this.card);
            } else {
                table.select(this.card);
            }
        }.bind(this),

        onDragStart: function () {
            if (!table.selected.has(this.card)) {
                if (!EditorCardTable.IsMultiSelectPressed()) {
                    table.clearSelection();
                }
                table.select(this.card);
            }
            return true;
        }.bind(this),

        onDragMove: function (touch) {
            move(touch, false);
        },

        onDragEnd: function (touch) {
            move(touch, true);
        }
    });
};

cleverapps.styles.CardViewControls = {
    rotate: [
        {
            x: { align: "right", dx: 10 },
            y: { align: "top", dy: 12 },
            rotate: -90,
            baseAngle: 32
        },
        {
            x: { align: "right", dx: 10 },
            y: { align: "bottom", dy: -10 },
            rotate: 0,
            baseAngle: 147
        },
        {
            x: { align: "left", dx: -10 },
            y: { align: "bottom", dy: -10 },
            rotate: 90,
            baseAngle: -147
        },
        {
            x: { align: "left", dx: -10 },
            y: { align: "top", dy: 12 },
            rotate: 180,
            baseAngle: -32
        }
    ],

    delete: {
        x: { align: "center" },
        y: { align: "bottom", dy: -20 }
    },

    orderdown: {
        x: { align: "left", dx: -8 },
        y: { align: "center" }
    },

    orderup: {
        x: { align: "right", dx: 8 },
        y: { align: "center" }
    },

    point: {
        x: { align: "left" },
        y: { align: "bottom" }
    }
};
